import React, { useEffect, useRef } from 'react';
import { useLmxStore } from './lmxStore';
import { LmxCard } from './LmxCards';

const OPENING = {
  text: '¿Comenzamos con algo nuevo o editamos algo que ya tenés?',
  chips: [
    {
      label: 'Crear algo nuevo',
      primary: true,
      action: { type: 'message', text: 'Quiero crear algo nuevo.' },
    },
    {
      label: 'Editar uno de mis flujos',
      action: { type: 'message', text: 'Quiero editar uno de mis flujos: mostrame mis proyectos.' },
    },
    {
      label: 'Hacer mi versión de un modelo',
      action: { type: 'message', text: 'Quiero hacer mi versión de una plantilla.' },
    },
  ],
};

/** El globo del avatar: muestra el último turno (el historial va en el log). */
export const LmxBubble = ({ onAction }) => {
  const { turn, busy, pendingConfirm } = useLmxStore();
  const ref = useRef(null);
  const empty = !turn.text && turn.cards.length === 0;

  useEffect(() => {
    if (ref.current) ref.current.scrollTop = ref.current.scrollHeight;
  }, [turn, pendingConfirm]);

  return (
    <div className="lmx-bubble is-left is-wide" role="status" aria-live="polite"
         data-testid="lmx-bubble">
      <div className="lmx-bubble-in" ref={ref}>
        {empty && !busy && (
          <>
            <p className="lmx-say">{OPENING.text}</p>
            <LmxCard card={{ type: 'chips', items: OPENING.chips }} onAction={onAction} />
          </>
        )}

        {empty && busy && (
          <div className="lmx-typing" data-testid="lmx-typing"><i /><i /><i /></div>
        )}

        {turn.text && <p className="lmx-say" data-testid="lmx-answer">{turn.text}</p>}
        {turn.cards.map((card, i) => (
          <LmxCard key={i} card={card} onAction={onAction} />
        ))}

        {pendingConfirm && (
          <div className="lmx-confirm" data-testid="lmx-confirm">
            <p className="lmx-confirm-sum">{pendingConfirm.summary}</p>
            {pendingConfirm.cost > 0 && (
              <p className="lmx-confirm-cost">
                Cuesta <strong>{pendingConfirm.cost} créditos</strong>
              </p>
            )}
            <div className="lmx-chips">
              <button
                type="button"
                className="is-primary"
                onClick={() => onAction({ type: 'approve', confirm_id: pendingConfirm.id })}
                data-testid="lmx-approve"
              >
                Aprobar
              </button>
              <button
                type="button"
                onClick={() => onAction({ type: 'cancel', confirm_id: pendingConfirm.id })}
                data-testid="lmx-cancel"
              >
                Cancelar
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LmxBubble;
